module.exports = __webpack_public_path__ + "media/crosses/close-icon--white-d5df7380.svg";